var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.8368C5.17024 14.419 8.03298 15.1634 9.6 13.6L15.6 8L13.8468 6H20V12.4L18.4 10.8L12.4682 16.53C8.88147 19.1668 4.10488 15.786 4 12.8368Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V2H0V0Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22H24V24H0V22Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2H2V22H0V2Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H24V22H22V2Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimization);
export default __webpack_public_path__ + "static/media/Optimization.bc48e1e75bfc03b5651de73bce4cf1a2.svg";
export { ForwardRef as ReactComponent };